import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
}
export function CTAButton({
  children,
  href = '#pricing',
  className = ''
}: CTAButtonProps) {
  const isAnchor = href.startsWith('#');
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (isAnchor) {
      e.preventDefault();
      const el = document.getElementById(href.substring(1));
      if (el) el.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const classes = `
    block w-full text-center cursor-pointer
    px-4 py-3 sm:py-4
    font-button font-bold text-sm sm:text-lg uppercase tracking-wide
    rounded-md
    bg-brand-rose text-white
    hover:bg-[#A67578] hover:scale-[1.02] 
    transition-all duration-200
    border-b-4 border-[#8A5A5D] active:border-b-0 active:translate-y-1
    shadow-[0_4px_14px_0_rgba(184,135,138,0.39)] hover:shadow-[0_6px_20px_rgba(184,135,138,0.23)]
    ${className}
  `;
  return <a href={href} onClick={handleClick} target={isAnchor ? undefined : '_blank'} rel={isAnchor ? undefined : 'noopener noreferrer'} className={classes} data-id="element-36" data-mp="198wjv75v3e3j">
      {children}
    </a>;
}